import React, { useContext, useEffect } from 'react'
import './styles/Sidebar.css'
import { menuLinks } from "app/data/menuLinks"
import { Link, NavLink, useLocation } from "react-router-dom"
import { StoreContext } from "app/store/store"
import blueLogo from 'app/assets/images/web-logo-blue.png'
import { useState } from "react"

export default function Sidebar() {

  const { showMobileSidebar, setShowMobileSidebar } = useContext(StoreContext)
  const location = useLocation()
  const [showDropdown, setShowDropdown] = useState(null)

  const navLinksList = menuLinks
    ?.map((link, index) => {
      return <div
        key={index}
        className={`side-link ${location.pathname.includes(link.url) ? 'active' : ''}`}
      >
        {
          !link.sublinks ?
            <NavLink to={link.url}>
              {link.name}
            </NavLink> :
            <a 
              onClick={() => setShowDropdown(prev => prev === index ? null : index)}
              className={index === showDropdown ? 'active' : ''}
            >
              {link.name}
              <i className="fal fa-chevron-right" />
            </a>
        }
        {
          link.sublinks && 
          <div className={`side-sublink ${showDropdown === index ? 'show' : ''}`}>
            {link.sublinks?.map((sublink, index) => {
              return <Link
                key={index+100}
                to={sublink.url}
              >
                {sublink.name}
              </Link>
            })}
          </div>
        }
      </div>
    })

  useEffect(() => {
    if (showMobileSidebar) {
      setShowMobileSidebar(false)
    }
  }, [location])

  return (
    <>
      <div className={`sidebar ${showMobileSidebar ? 'show-mobile' : ''}`}>
        <div className="top">
          <img src={blueLogo} alt="logo" />
          <div className="menu">
            {navLinksList}
          </div>
        </div>
        <div className="bottom">
          <p>© 2023 All Rights Reserved Created by&nbsp; 
          </p>
        </div>
        <i
          className="fal fa-times close-sidebar"
          onClick={() => setShowMobileSidebar(false)}
        />
      </div>
      {
        showMobileSidebar &&
        <div
          className="mobile-sidebar-overlay"
          onClick={() => setShowMobileSidebar(false)}
        />
      }
    </>
  )
}
